export default "__VITE_ASSET__95c354df__"